import { t } from "i18next";
import PageTitle from "src/components/common/PageTitle/PageTitle";

export const WelcomeSection = () => {
    return <PageTitle>{t("homeModule.Welcome")}</PageTitle>;
};
